import {addMethod, string} from 'yup';

import {recaptchaEnabled} from 'helpers/environment';

addMethod(string, 'recaptcha', function validateRecaptcha() {
  return recaptchaEnabled
    ? this.nullable().required()
    : this.nullable().ensure().default('recaptcha_disabled');
});
